import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetOneExamType({ examTypeId, enabled = false } = {}) {
  const { privateFetch } = useContext(FetchContext);

  return useQuery(
    ['exam-type', examTypeId],
    () =>
      privateFetch
        .get(`/v1/admin/manage-podcasts/exam-info/exam-types/${examTypeId}`)
        .then((r) => r.data),
    { enabled: enabled && !!examTypeId, keepPreviousData: true }
  );
}

export default useGetOneExamType;
